import { render, staticRenderFns } from "./OtherTransactions.vue?vue&type=template&id=be31f6a0&"
import script from "./OtherTransactions.vue?vue&type=script&lang=js&"
export * from "./OtherTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports